<footer
  class="footer-area text-center bg-white border-top-radius"
  [class.card-borderd-theme]="themeService.isCardBorder()"
  [class.component-dark-theme]="themeService.isDark()"
>
    <!-- <p>
        © <span class="text-black fw-medium">Daxa</span> is Proudly Owned by <a href="https://hibootstrap.com/" target="_blank">HiBootstrap</a>
    </p> -->
  <p>
    © <span class="text-black fw-medium">2025</span>
  </p>
</footer>
